
import { Vue, Component, Prop } from 'vue-property-decorator';

import EditPenIcon from '@/components/icons/EditPenIcon.vue';
@Component({
	components: {
		EditPenIcon,
	},
})
export default class StepProgress extends Vue {
	@Prop({ type: Array, required: true }) steps!: Array<{ label: string }>;
	@Prop({ type: Number, default: 0 }) activeStep!: number;
	getStepClass(index: number): string {
		if (index < this.activeStep) return 'visited';
		if (index === this.activeStep) return 'current';
		return '';
	}

	isStepVisited(index: number): boolean {
		return index < this.activeStep;
	}
	isEditMode() {
		return this.$route.query.action === 'edit';
	}
}
